import { RouteConfig } from 'packages/route'
import { lazy } from 'react'

export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'admin/teacherManagement',
    name: 'AdminTeacherManagement',
    getTitle: () => '教师管理',
    component: lazy(() =>
      import('./pages/index').then((m) => ({
        default: m.TeacherManagement,
      }))
    ),
    subRoutes: [
      {
        path: 'internalTeachers',
        getTitle: () => '在校教师',
        component: lazy(() =>
          import('./pages/internalTeachers/InternalList').then((m) => ({
            default: m.InternalList,
          }))
        ),
      },
      {
        path: 'outgoingTeachers',
        getTitle: () => '离校教师',
        component: lazy(() =>
          import('./pages/outgoingTeachers/OutgoingList').then((m) => ({
            default: m.OutgoingList,
          }))
        ),
      },
    ],
  },
  {
    path: 'admin/teacherManagement/internalTeachers/details/:id',
    name: 'AdminInternalTeacherDetail',
    getTitle: () => '教师详情',
    component: lazy(() =>
      import('./pages/components/Detail').then((m) => ({
        default: m.Detail,
      }))
    ),
  },
  {
    path: 'admin/teacherManagement/internalTeachers/add-teacher',
    name: 'AddInternalTeacher',
    getTitle: () => '新增教师',
    component: lazy(() =>
      import('./pages/components/AddTeacher').then((m) => ({
        default: m.AddTeacher,
      }))
    ),
  },
  {
    path: 'admin/teacherManagement/internalTeachers/fields-management',
    name: 'InternalTeachersFieldSetting',
    getTitle: () => '字段设置',
    component: lazy(() =>
      import('./pages/components/FieldSetting').then((m) => ({
        default: m.FieldSetting,
      }))
    ),
  },
  {
    path: 'admin/teacherManagement/outgoingTeachers/details/:id',
    name: 'AdminOutgoingTeacherDetail',
    getTitle: () => '教师详情',
    component: lazy(() =>
      import('./pages/components/Detail').then((m) => ({
        default: m.Detail,
      }))
    ),
  },
  {
    path: 'admin/teacherManagement/outgoingTeachers/fields-management',
    name: 'OutgoingTeachersFieldSetting',
    getTitle: () => '字段设置',
    component: lazy(() =>
      import('./pages/components/FieldSetting').then((m) => ({
        default: m.FieldSetting,
      }))
    ),
  },
]
